import { z } from 'zod';

import { toLatinDigits } from '@/shared/utils/formatters';
import { nameSchema, noteSchema } from '@/shared/validation/common';

/** Mirrors `ComplexCreate`: name 1–100, city ≤50, optional referral code. */
export const createComplexSchema = z.object({
  name: nameSchema(100, 'نام مجتمع'),
  city: nameSchema(50, 'شهر'),
  referral_code: z
    .string()
    .trim()
    .max(50, 'کد معرف نباید بیشتر از ۵۰ نویسه باشد')
    .optional()
    .or(z.literal('').transform(() => undefined)),
});
export type CreateComplexForm = z.input<typeof createComplexSchema>;

/** Mirrors `BuildingCreate`: name 1–100; `complex_id` is set by the caller. */
export const createBuildingSchema = z.object({
  name: nameSchema(100, 'نام ساختمان'),
});
export type CreateBuildingForm = z.input<typeof createBuildingSchema>;

/** Mirrors `UnitCreate`: name 1–50. */
export const createUnitSchema = z.object({
  name: nameSchema(50, 'نام واحد'),
});
export type CreateUnitForm = z.input<typeof createUnitSchema>;

/**
 * Join codes are generated server-side as short alphanumerics. Digits are
 * normalised because a Persian keyboard produces Persian ones, and the code is
 * upper-cased so the lookup is case-insensitive from the user's side.
 */
export const joinCodeSchema = z.object({
  code: z
    .string()
    .trim()
    .transform((value) => toLatinDigits(value).replace(/\s/g, ''))
    .pipe(
      z
        .string()
        .min(4, 'کد عضویت را کامل وارد کنید')
        .max(32, 'کد عضویت معتبر نیست')
        .regex(/^[A-Za-z0-9-]+$/, 'کد عضویت فقط شامل حروف و اعداد است'),
    ),
});
export type JoinCodeForm = z.input<typeof joinCodeSchema>;

export const membershipRequestSchema = z.object({
  unit_id: z.string().uuid('واحد خود را انتخاب کنید'),
  note: noteSchema,
});
export type MembershipRequestForm = z.input<typeof membershipRequestSchema>;
